export const CommunityAvatar = ({ title }) => (
  <div className="flex items-center justify-center w-16 h-16 text-xl text-white rounded-xl bg-secondaryColor">
    <h1>{title[0]}</h1>
  </div>
)
